import { ProjectContext } from "common/contexts/ProjectContext";
import { useContext } from "react";

export function useProject() {
  return useContext(ProjectContext);
}
